import React, {Component} from 'react';
import {
  Accordion,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
}                         from 'semantic-ui-react';
import _                  from 'lodash';
import ReactHtmlParser    from 'react-html-parser';
import PropTypes          from 'prop-types';

// Global
import getMessage         from '../../global/getMessage';
// Controller
import globalController   from '../../global/globalcontroller';
// Images
// import musiclesson        from '../../images/instruments.jpg';
import price              from '../../images/price.png';

// Style
import                    '../MainStyle/MainTwo.scss';
import                    './MainPrice.scss';

const images = require.context('../../images', true);

const propTypes = {
  content : PropTypes.arrayOf(PropTypes.object),
  lang    : PropTypes.shape({menu: PropTypes.object}),
};
const defaultProps = {
  content : null,
  lang    : {},
};

class MainPrice extends Component {

  constructor() {
    super();
    this.state = {activeIndex: 10};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(idx) {
    const {activeIndex} = this.state;
    this.setState({activeIndex: idx === activeIndex ? 10 : idx});
  }

  render() {
    const {activeIndex} = this.state;
    const {lang} = this.props;
    const contentMsg = this.props.content || getMessage('section.price.content', lang);
    const content = [];

    _.forOwn(contentMsg, (value, key) => {
      content.push(
        <p key={key}>
          {value}
        </p>
      );
    });

    // Special Workshops
    const contentSpecialMainTitle = getMessage('section.price.specialworkshop.main_title', lang);
    const contentSpecialTitle = getMessage('section.price.specialworkshop.title', lang);
    const contentSpecialContent = getMessage('section.price.specialworkshop.content', lang);
    const contentSpecial = [];
    const contentSpecialImg = getMessage('section.price.images', lang);

    Object.keys(contentSpecialTitle).forEach((key, idx) => {
      contentSpecial.push(
        <React.Fragment key={key}>
          <Divider />
          <Accordion.Title
            active={activeIndex === idx}
            index={idx}
            key={key}
            onClick={() => this.handleClick(idx)}
          >
            <Icon name='dropdown' />
            {contentSpecialTitle[key]}
          </Accordion.Title>
          <Accordion.Content active={activeIndex === idx}>
            <img src={images('./' + contentSpecialImg[idx][0])} />
            {contentSpecialContent[key]}
          </Accordion.Content>
        </React.Fragment>
      );
    });

    return (
      <Container className='sgr-mainHome-grid-two-sub'>

        <Divider hidden />

        <Header
          as='h2'
          color='grey'
          inverted
          textAlign='center'
        >
          <Header.Content>
            {ReactHtmlParser(getMessage('menu.price', lang))}
          </Header.Content>
        </Header>

        {content}

        <Grid divided='vertically'>
          <Grid.Row columns={1}>
            <Grid.Column>
              <Image src={price} />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <p>
          {contentSpecialMainTitle[0]}
        </p>
        <Accordion>
          {contentSpecial}
        </Accordion>

      </Container>
    );
  }

}

MainPrice.propTypes = propTypes;
MainPrice.defaultProps = defaultProps;

export default globalController(MainPrice);



// WEBPACK FOOTER //
// ./src/organisms/MainPrice/MainPrice.js